module.exports = __webpack_public_path__ + "assets/img/3-1.7ab2bb04.jpg";